export const fixBodyUrl = (body: string): string => {
    return body.replaceAll("(/media/", "(/assets/media/");
}